import { SvgIcon } from "@mui/material"

export const InvitePartnerIcon = () => (
	<SvgIcon color="primary">
		<svg
			version="1.1"
			viewBox="0 0 1000 1000"
			width="250"
			height="250"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				transform="translate(398,512)"
				d="m0 0h151l23 2 22 4 31 10 12 5 18 10 14 9 11 9 10 9 2 1v2l4 2 8 8 11 14 11 15 11 19 11 23 8 25 5 22 2 19v24l-2 16-3 12-4-2-8-8-12-7-12-4-17-3v-24l-3-18-7-25-7-16-10-19-12-16-7-8-10-10-14-11-20-12-19-7-21-6-41-2h-124l-40 2-23 6-16 6-20 11-11 8-11 9-13 13-12 16-8 14-8 15-8 24-4 18-1 10v13l2 11 5 8 5 4 13 5 6 1 27 1h201l-6 8-4 5-5 9-2 6v9l4 12 3 7v5l-23 1h-71l-93-1-42-2-17-4-17-7-10-6-13-11-8-10-7-12-6-18-3-15v-24l4-26 7-25 7-19 10-20 10-17 13-17 9-11 2-3h2l2-4 11-10 11-9 12-9 24-14 17-8 35-11 19-3 14-2z"
				fill="#7BA7BD"
			/>
			<path
				transform="translate(463,96)"
				d="m0 0h26l23 2 15 3 16 5 13 6 17 9 14 10 13 11 14 14 13 17 9 15 10 21 6 18 3 21 1 27-1 21-3 19-5 17-7 17-11 19-12 16-12 13-11 11-16 12-16 9-15 7-17 6-21 6-18 3h-30l-12-2-26-7-16-6-21-10-11-7-12-9-10-9-7-6-9-11-10-13-9-15-10-21-6-18-5-27-1-10v-16l3-25 4-15 7-20 13-25 8-12 13-15 14-14 14-11 19-12 17-8 20-6 14-3zm6 61-23 4-21 8-14 9-10 8-10 9-13 18-8 16-5 16-4 22v11l3 19 4 16 5 12 8 14 11 14 13 12 14 9 16 8 7 3 19 4 11 1h15l20-4 20-7 15-9 12-9 8-7 11-14 8-13 5-12 5-17 3-17v-13l-4-24-6-18-10-18-10-13-7-7-14-11-18-10-16-6-15-3-10-1z"
				fill="#7BA7BD"
			/>
			<path
				transform="translate(625,694)"
				d="m0 0h12l10 4 8 8 5 9v65h56l8 3 10 9 6 9 2 4v7l-9 14-8 7-8 3-10 1h-46l-1 64-2 9-7 10-5 4-5 3-8 2-8-1-9-4-6-5-6-10-1-4-1-68h-60l-12-5-8-8-4-6-2-7 1-9 5-10 4-2v-2l11-7 3-1 63-1-1-31v-29l4-11 8-9 7-4z"
				fill="#7BA7BD"
			/>
		</svg>
	</SvgIcon>
)

export const TasksIcon = () => (
	<SvgIcon color="primary">
		<svg
			version="1.1"
			viewBox="0 0 1000 1000"
			width="250"
			height="250"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				transform="translate(398,512)"
				d="m0 0h151l23 2 22 4 31 10 12 5 18 10 14 9 11 9 10 9 2 1v2l4 2 8 8 11 14 11 15 11 19 11 23 8 25 5 22 2 19v24l-2 16-3 12-4-2-8-8-12-7-12-4-17-3v-24l-3-18-7-25-7-16-10-19-12-16-7-8-10-10-14-11-20-12-19-7-21-6-41-2h-124l-40 2-23 6-16 6-20 11-11 8-11 9-13 13-12 16-8 14-8 15-8 24-4 18-1 10v13l2 11 5 8 5 4 13 5 6 1 27 1h201l-6 8-4 5-5 9-2 6v9l4 12 3 7v5l-23 1h-71l-93-1-42-2-17-4-17-7-10-6-13-11-8-10-7-12-6-18-3-15v-24l4-26 7-25 7-19 10-20 10-17 13-17 9-11 2-3h2l2-4 11-10 11-9 12-9 24-14 17-8 35-11 19-3 14-2z"
				fill="#7BA7BD"
			/>
			<path
				transform="translate(463,96)"
				d="m0 0h26l23 2 15 3 16 5 13 6 17 9 14 10 13 11 14 14 13 17 9 15 10 21 6 18 3 21 1 27-1 21-3 19-5 17-7 17-11 19-12 16-12 13-11 11-16 12-16 9-15 7-17 6-21 6-18 3h-30l-12-2-26-7-16-6-21-10-11-7-12-9-10-9-7-6-9-11-10-13-9-15-10-21-6-18-5-27-1-10v-16l3-25 4-15 7-20 13-25 8-12 13-15 14-14 14-11 19-12 17-8 20-6 14-3zm6 61-23 4-21 8-14 9-10 8-10 9-13 18-8 16-5 16-4 22v11l3 19 4 16 5 12 8 14 11 14 13 12 14 9 16 8 7 3 19 4 11 1h15l20-4 20-7 15-9 12-9 8-7 11-14 8-13 5-12 5-17 3-17v-13l-4-24-6-18-10-18-10-13-7-7-14-11-18-10-16-6-15-3-10-1z"
				fill="#7BA7BD"
			/>
			<path
				transform="translate(625,694)"
				d="m0 0h12l10 4 8 8 5 9v65h56l8 3 10 9 6 9 2 4v7l-9 14-8 7-8 3-10 1h-46l-1 64-2 9-7 10-5 4-5 3-8 2-8-1-9-4-6-5-6-10-1-4-1-68h-60l-12-5-8-8-4-6-2-7 1-9 5-10 4-2v-2l11-7 3-1 63-1-1-31v-29l4-11 8-9 7-4z"
				fill="#7BA7BD"
			/>
		</svg>
	</SvgIcon>
)

export const BudgetIcon = () => (
	<SvgIcon>
		<svg
			version="1.1"
			viewBox="0 0 1000 1000"
			width="250"
			height="250"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				transform="translate(653,93)"
				d="m0 0h50l20 5 13 7 11 8 7 7 4 8 1 3v12l-5 21-19 75-9 34 1 5 10 9 9 9 7 8 11 12 9 11 8 10 9 15 2 2 42 8 26 5 16 5 6 4 6 9 2 7 8 93 4 45 1 10v21l-6 10-10 6-16 3-37 16-9 4-4 13-11 28-9 16-16 27-7 11-2 2 1 5 2 6 14 96 6 40-3 10-5 8-6 5-11 5-43 17-27 11-38 15-9 4-6 1h-10l-8-3-10-9-12-14-13-15-12-14-10-11-9-11-7-8-3-3-23 3-22 2-30 1-31-2-18-2-25-5-35-10-27-9-16-8-4 2-16 15-13 13h-2v2l-8 7-14 14-8 7-10 10-11 8-8 3-13-2-16-6-21-11-60-30-10-8-4-8-2-6 1-7 6-18 17-62 15-55 8-29 4-9-3-10-10-30-5-22-3-19-2-22v-28l3-32 5-26 9-30 10-24 9-17 2-4-1-8-6-12-10-7-20-9 1 5v14l-4 13-6 9-5 6-11 8-11 3h-14l-12-4-9-7-7-9-4-10v-19l2-7-11 7-10 5-4 1-8-3-6-7-2-5 1-7 4-6 7-6 16-9 13-6 4-1h38l7 2 13-1h22l17 7 17 8 14 10 6 8v2l5-5 11-13 11-12 3-4h2l2-4 15-15 17-13 21-16 14-9 27-14 23-11 27-9 39-11 23-4 36-3h28l28 1 7-12 13-14 7-8 19-19 11-9 16-13 13-8 16-7zm12 52-17 5-12 6-10 8-13 10-17 16-12 12-11 15-7 11-8 11-4 8-12-1-23-3-19-1h-26l-28 2-22 4-43 12-16 6-44 22-15 11-17 13-10 8-14 14-7 8-11 12-10 13-13 22-9 16-8 17-8 24-5 21-3 19-1 20v18l2 25 5 26 8 26 5 12v8l-15 72-9 38-14 52-3 10v5l56 28 4-1 36-33 13-12 11-10-1-5-7-7-9-12-4-10 1-9 4-8 7-6 9-3 9 1 10 6 9 10 9 11 7 7 28 15 15 6 49 14 25 4 9 1 21 1h17l28-2 26-4 19-6 14-8 22-15 9-5 5-2h8l10 4 6 7 3 7v10l-5 10-8 7-20 13-6 4 1 4 4 7 9 11 9 10 7 8 12 14 3 4 9-3 55-22 26-10 1-4-3-20-7-50-3-17-2-35-2-20v-7l9-11 14-23 12-21 7-16 8-24 4-16 2-9 6-3 27-8 18-6 10-3 9-5v-10l-9-104-5-2-30-4-44-8-7-2-2-5-18-30-7-9-9-10-7-8-9-10-10-10-17-13-9-7 1-18 4-17 4-20 7-23 13-51 5-19-1-4-22-2zm-568 191-7 8-1 2v6l4 5 4 1 7-4 3-5v-7l-5-6z"
				fill="#7BA7BE"
			/>
			<path
				transform="translate(480,278)"
				d="m0 0 39 1 9 5 6 9 1 7-4 10-8 7-9 2-55 1-33 5-33 11-11 6-16 10-8 4-8 1-9-4-5-5-3-6v-11l6-9 10-7 23-14 24-9 22-7 24-4 18-2z"
				fill="#7BA7BE"
			/>
			<path
				transform="translate(671,396)"
				d="m0 0 14 1 12 6 8 8 5 8 3 10v10l-4 11-6 9-8 7-8 4-4 1h-17l-10-4-10-9-6-9-3-9v-12l4-11 6-9 7-6 8-4z"
				fill="#7BA7BE"
			/>
		</svg>
	</SvgIcon>
)

export const VendorTrackerIcon = () => (
	<SvgIcon>
		<svg
			version="1.1"
			viewBox="0 0 1000 1000"
			width="250"
			height="250"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				transform="translate(269,313)"
				d="m0 0h32l22 2 18 4 14 7 10 8 7 10 4 11 1 10-1 5 2 49 63 1 295 1 21 3 23 6 15 6 16 9 12 9 6 5 7 8 11 14 8 15 7 19 4 17 2 19v241l-2 17-5 16-5 12-7 13-7 9-9 10-11 10-20 12-19 8-21 6-30 5-9 1-21 1h-171l-296-1-16-2-20-4-24-8-18-10-12-9-15-15-12-17-8-17-6-19-3-15-2-21-1-31-2-114v-92l3-18 4-13 10-21 10-14 13-13 10-8 16-9 15-7 23-7 16-3 13-2 1-7 2-55 2-14 5-12 6-9 8-6 12-5zm11 48-1 14v45h50v-24l-1-30-2-2-15-2-15-1zm-21 114-23 2-19 3-20 6-16 8-11 8-9 11-5 11-3 11-1 7v88l1 34 1 75 1 36 2 16 4 15 8 16 7 9 9 8 15 8 16 5 21 3 107 1 231 1h103l37-1 29-4 16-4 15-6 14-8 8-7 7-10 5-12 3-13v-127l2-3v-38l-1-50-1-23-3-17-5-15-7-12-9-10-10-7-12-6-16-5-27-3-224-1z"
				fill="#7BA6BE"
			/>
			<path
				transform="translate(481,484)"
				d="m0 0 23 1 20 3 21 6 14 5 22 12 14 10 10 8 10 9 11 12 11 15 9 15 9 19 7 21 3 14 2 16v32l-3 20-7 25-9 21-11 19-10 13-9 10-5 6-8 7-15 12-24 14-17 7-23 7-20 3-12 1h-18l-21-2-18-4-21-7-25-13-14-10-11-9-10-9-9-10-13-17-10-18-8-17-8-26-3-20-1-11v-18l3-23 6-23 8-21 10-18 8-12 14-17 13-13 17-13 22-13 16-7 22-7 16-3zm-3 48-25 4-17 5-16 8-14 9-15 13-10 11-9 13-9 17-7 21-3 17-1 8v14l3 23 6 20 8 16 5 9 7 9 11 13 13 11 14 9 16 8 18 6 19 3 11 1h9l26-4 21-7 19-10 12-9 12-11 11-12 9-14 10-21 5-19 3-21v-9l-3-25-6-20-5-12-8-14-10-13-10-11-14-11-11-7-16-8-18-6-17-3-11-1z"
				fill="#7BA6BE"
			/>
			<path
				transform="translate(413,157)"
				d="m0 0h7l9 4 6 5 5 10 17 56 12 40 14 47 9 30 2 11-4 10-7 8-9 4h-9l-10-5-7-8-5-13-12-41-15-49-9-31-13-43-2-9 1-9 6-10 10-6z"
				fill="#7BA6BE"
			/>
			<path
				transform="translate(574,141)"
				d="m0 0h10l8 3 6 5 4 6 1 3v19l-11 82-6 49-5 36-3 14-7 9-8 4h-13l-7-3-7-7-3-6-1-5 1-15 6-44 7-56 8-62 3-16 5-8 7-6z"
				fill="#7BA6BE"
			/>
			<path
				transform="translate(736,203)"
				d="m0 0h10l10 5 6 7 3 7v9l-6 12-70 98-12 17-12 16-8 6-10 3-8-2-9-6-5-8-2-5v-8l7-14 10-13 11-16 14-19 9-13 13-18 12-17 20-28 8-9z"
				fill="#7BA6BE"
			/>
			<path
				transform="translate(479,548)"
				d="m0 0 13 2 8 6 6 12v9l-6 11-8 6-16 3-20 3-14 7-8 8-9 12-8 16-8 15-4 5-8 4-4 1h-8l-9-4-6-5-4-8-1-3v-7l5-13 11-23 8-11 10-11 7-8 10-9 14-8 13-5 15-3z"
				fill="#7BA6BE"
			/>
		</svg>
	</SvgIcon>
)
